import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import { connect } from "react-redux";

import Home from "../themes/home";
import Privacypolicy from "../themes/privacypolicy";
import Termsofuse from "../themes/termsofuse";
import NotFound from "../components/NotFound";

class AppRoutes extends React.Component {
  render() {
    return (
      <Router>
        <Routes>
          {/* Define specific routes */}
          <Route path="/" element={<Home />} />
          <Route path="/privacypolicy" element={<Privacypolicy />} />
          <Route path="/termsofuse" element={<Termsofuse />} />

          {/* 404 Page */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    );
  }
}

export default connect((state) => ({
  state,
}))(AppRoutes);